(function () {
  if (!matchMedia('(pointer: fine)').matches) return;

  var URL_DEFAULT = window.CURSOR_SVG;                 // set in theme.liquid
  var URL_HOVER   = window.CURSOR_SVG_HOVER || URL_DEFAULT;
  if (!URL_DEFAULT) return;

  // Hotspot: pixels from the image's top-left to the click point
  var HOTSPOT_PX_X = 10;
  var HOTSPOT_PX_Y = 6;

  // Build DOM
  var root  = document.createElement('div');  // translates only
  root.className = 'svg-cursor';
  root.setAttribute('aria-hidden', 'true');

  var inner = document.createElement('div');  // scales only
  inner.className = 'svg-cursor__img';
  inner.style.setProperty('--hotspot-x', HOTSPOT_PX_X + 'px');
  inner.style.setProperty('--hotspot-y', HOTSPOT_PX_Y + 'px');

  var imgDefault = new Image(); imgDefault.alt = ''; imgDefault.draggable = false; imgDefault.src = URL_DEFAULT;
  var imgHover   = new Image(); imgHover.alt   = ''; imgHover.draggable   = false; imgHover.src   = URL_HOVER;

  imgDefault.style.display = 'block';
  imgHover.style.display   = 'none';

  inner.appendChild(imgDefault);
  inner.appendChild(imgHover);
  root.appendChild(inner);
  document.body.appendChild(root);
  document.body.classList.add('use-svg-cursor');

  var rafId = null, x = 0, y = 0, moved = false, isHovering = false;

  function setPos() {
    // Translate wrapper so the hotspot sits under the mouse
    root.style.transform = 'translate(' + (x - HOTSPOT_PX_X) + 'px,' + (y - HOTSPOT_PX_Y) + 'px)';
  }

  function onMove(e) {
    x = e.clientX; y = e.clientY;
    if (!moved) { root.style.opacity = '1'; moved = true; }
    if (!rafId) rafId = requestAnimationFrame(function () { setPos(); rafId = null; });
    updateHoverState(e.target);
  }

  var CLICK_SEL = [
    'a[href]',
    'button:not(:disabled)',
    '[role="button"]',
    'input[type="submit"]:not(:disabled)',
    'input[type="button"]:not(:disabled)',
    'label[for]',
    'select:not(:disabled)',
    'summary',
    '[data-clickable]',
    '[onclick]',
    '.cursor-pointer',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function updateHoverState(node) {
    var el = node && node.closest ? node.closest(CLICK_SEL) : null;
    var next = !!el;
    if (next === isHovering) return;
    isHovering = next;

    if (isHovering) {
      imgDefault.style.display = 'none';
      imgHover.style.display   = 'block';
      root.classList.add('is-clickable');
    } else {
      imgDefault.style.display = 'block';
      imgHover.style.display   = 'none';
      root.classList.remove('is-clickable');
    }

    // Snap to correct base scale on state change (no jump)
    inner.style.scale = isHovering ? '1.5' : '1.25';
  }

  addEventListener('mousemove', onMove, { passive: true });

  // Click feedback: scale the INNER only (keeps hotspot fixed)
  addEventListener('mousedown', function () {
    var base = isHovering ? 1.5 : 1.25;
    inner.style.scale = String(base * 0.95);
  });
  addEventListener('mouseup', function () {
    inner.style.scale = isHovering ? '1.5' : '1.25';
  });

  // Prevent ghost cursor on tab switch
  document.addEventListener('visibilitychange', function () {
    root.style.opacity = document.visibilityState === 'visible' ? '1' : '0';
  });
})();
